<template>
  <div class="admin-nav-wrapper" v-if="authed">
    <nav class="admin-nav">
      <router-link
        v-for="(item, index) in navItems"
        :key="index"
        :to="item.path"
        class="admin-nav-item"
        :class="{ active: $route.path.startsWith(item.path) }"
      >
        {{ $t(item.label) }}
      </router-link>
    </nav>
    <div class="nav-actions">
      <button class="btn-icon logout" @click="logout" :title="$t('common.logout')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { logout as apiLogout } from '../api'
import { ref } from 'vue'

const router = useRouter()
const authed = ref(true)

const navItems = [
  { path: '/admin/pages', label: 'admin.pages' },
  { path: '/admin/landing', label: 'landing.manage' },
  { path: '/admin/messages', label: 'admin.messages' },
  { path: '/admin/members', label: 'nav.members' },
  { path: '/admin/gallery', label: 'admin.gallery' },
  { path: '/admin/albums', label: 'admin.albums' },
  { path: '/admin/users', label: 'admin.users' },
  { path: '/admin/appearances', label: 'admin.appearances' },
  { path: '/admin/analytics', label: 'analytics.title' },
  { path: '/admin/settings', label: 'admin.settings' }
]

async function logout() {
  await apiLogout()
  authed.value = false
  window.dispatchEvent(new CustomEvent('auth-logout'))
  router.push('/')
}
</script>

<style scoped>
.admin-nav-wrapper {
  display: flex;
  align-items: center;
  background: var(--admin-surface, #222);
  border: 1px solid var(--admin-border, #444);
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: var(--admin-radius, 8px);
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  gap: 1rem;
}

.nav-brand {
  font-weight: 800;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 1px;
  color: var(--accent, orange);
  flex-shrink: 0;
}

.admin-nav {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  overflow-x: auto;
  flex: 1;
  /* Hide scrollbar but allow scrolling */
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 0.25rem 0;
}
.admin-nav::-webkit-scrollbar {
  display: none;
}

.admin-nav-item {
  text-decoration: none;
  color: inherit;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  white-space: nowrap;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.admin-nav-item:hover {
  background: rgba(128, 128, 128, 0.1);
  opacity: 1;
}

.admin-nav-item.active {
  background: var(--accent, orange);
  color: #fff; /* Contrast text */
  opacity: 1;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-actions {
  border-left: 1px solid var(--admin-border, #444);
  padding-left: 0.5rem;
}

.btn-icon {
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  color: #ef4444; /* Red for logout */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.btn-icon:hover {
  background: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
  transform: scale(1.1);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
.btn-icon:active {
  transform: scale(0.95);
}

@media (max-width: 640px) {
  .admin-nav-wrapper {
    flex-wrap: wrap;
    padding: 0.75rem;
  }
  .admin-nav {
    order: 3;
    width: 100%;
    margin-top: 0.5rem;
    border-top: 1px solid var(--admin-border, #444);
    padding-top: 0.5rem;
  }
  .nav-actions {
    margin-left: auto;
    border-left: none;
  }
}
</style>
